export default __webpack_public_path__ + "static/media/Test.31d6cfe0.bin";